module.exports = __webpack_public_path__ + "06_bob_gold.da3365d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/06_bob_gold.png
// module id = T9sn
// module chunks = 0